import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/pages/index/our_expertise/services.jpg")